import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const voyadoPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('voyado:profile:received', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetProfileReceived(payload),
  );

  partnerEvents.on('voyado:messages:received', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetMessagesReceived(payload),
  );

  partnerEvents.on('voyado:message:external-link:opened', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetMessageExternalLinkOpened(payload),
  );

  partnerEvents.on('voyado:channel:unsubscribe:clicked', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetChannelUnsubscriptionClicked(payload),
  );

  partnerEvents.on('voyado:channel:unsubscribe:succeeded', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetChannelUnsubscriptionSucceeded(
      payload,
    ),
  );

  partnerEvents.on('voyado:channel:unsubscribe:failed', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetChannelUnsubscriptionFailed(payload),
  );

  partnerEvents.on('voyado:channel:subscribe:clicked', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetChannelSubscriptionClicked(payload),
  );

  partnerEvents.on('voyado:channel:subscribe:succeeded', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetChannelSubscriptionSucceeded(payload),
  );

  partnerEvents.on('voyado:channel:subscribe:failed', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetChannelSubscriptionFailed(payload),
  );

  partnerEvents.on('voyado:transactions:received', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetTransactionsReceived(payload),
  );

  partnerEvents.on('voyado:orders:received', (payload) =>
    ampli.partnerIntegrationsVoyadoWidgetOrdersReceived(payload),
  );

  partnerEvents.on('voyado:update:points:succeeded', (payload) =>
    ampli.partnerIntegrationsWidgetVoyadoUpdatePointsSucceeded(payload),
  );

  partnerEvents.on('voyado:update:points:failed', (payload) =>
    ampli.partnerIntegrationsWidgetVoyadoUpdatePointsFailed(payload),
  );
};
